import { render, staticRenderFns } from "./ApplicantIdentityVerification.vue?vue&type=template&id=748900f2&"
import script from "./ApplicantIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./ApplicantIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports